module.exports = __webpack_public_path__ + "img/cash-on-delivery-color.74c5c06c.png";